import React from "react";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Avatar,
  Grid,
} from "@mui/material";

// Custom styles to match the subtle colors and border radii from the image
const styles = {
  paper: {
    borderRadius: 4,
  },
  avatar: {
    width: 60,
    height: 60,
    bgcolor: "rgb(235, 237, 239)",
    color: "rgb(108, 117, 125)",
    fontSize: 28,
    fontWeight: 600,
  },
  // Style for the input value text inside the disabled field
  textField: {
    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: '#343a40', // Matches dark text color
    },
    // The image inputs appear slightly smaller than default, 'small' size helps here.
  },
  // Style for the label text (e.g., "Name", "Mobile Number") placed above the box
  fieldLabel: {
    fontSize: '0.875rem', // Smaller text size for the label
    color: '#6c757d', // A medium grey color for the label text
    marginBottom: 0.5, // Small margin below the label before the input box
  },
  heading: {
    fontWeight: 700,
    fontSize: '1.25rem',
    marginBottom: '1rem',
    color: '#343a40',
  }
};

const Profile = ({ user }) => {

  // Helper function to render a field with an external label
  const role = user?.role?.name || user?.role;
  const renderField = (label, value) => (
    <Box>
      <Typography sx={styles.fieldLabel}>
        {label}
      </Typography>
      <TextField
        size="small"
        // IMPORTANT: We remove the 'label' prop here
        value={value}
        disabled
        fullWidth
        variant="outlined"
        sx={styles.textField}
      />
    </Box>
  );

  return (
    <Box sx={{ p: 2, pt: 1, mt: -2 }}>
       {/* HEADER */}
      <Typography variant="h5" fontWeight="bold">
        Profile
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={2}>
      View and manage your personal information
      </Typography>

      {/* 1. Top User Info Card */}
      <Paper sx={{ display: "flex", p: 3, alignItems: "center", gap: 2, ...styles.paper }}>
        {/* Avatar (V) */}
        <Avatar sx={styles.avatar}>
          {user.avatarText || user?.username?.charAt(0)?.toUpperCase() || "U"}
        </Avatar>

        {/* Name and Email */}
        <Box>
          <Typography fontSize={18} fontWeight={600} color="#343a40">
            {user?.username}
          </Typography>
          <Typography variant="body2" color="text.secondary" fontSize={14}>
            {user?.email}
          </Typography>
        </Box>
      </Paper>

      {/* 2. Profile Details Box - Basic Information */}
      <Paper sx={{ mt: 3, p: 3, ...styles.paper }}>
        <Typography sx={styles.heading}>
          Basic Information
        </Typography>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
          
          {/* Row 1: Name */}
          <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
            {renderField("Name", user?.username)}
          </Box>

          {/* Organization Name */}
          <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
            {renderField("Organization Name", user?.company?.name)}
          </Box>

          {/* Mobile Number */}
          <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
            {renderField("Mobile Number", user?.contactNumber)}
          </Box>

          {/* User Role */}
          <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
            {renderField("User Role", role)}
          </Box>

          {/* Email (Full Width) */}
          <Box sx={{ width: "100%" }}>
            {renderField("Email", user?.email)}
          </Box>

        </Box>
      </Paper>

    </Box>
  );
};

export default Profile;